import store from '../store';

const orgRoutes = [
	{ 
		path: '/admin/orgs',
		name: 'orgs.index', 
		component: require('../pages/orgs/OrgsIndex.vue').default,
		async beforeEnter(to, from, next) {
			try {
				var perms = await store.state.perms;
				if (perms.can_create_org) {
					next();
				}
				else {
					next('/error');
				}
			} catch (e) {
				next('/error');
			}
		}		
	},	

	{ 
		path: '/admin/orgs/create',
		name: 'orgs.create', 
		component: require('../pages/orgs/OrgItemCreate.vue').default,
		async beforeEnter(to, from, next) {
			try {
				var perms = await store.state.perms;
				if (perms.can_create_org) {
					next();
				}
				else {
					next('/error');
				}
			} catch (e) {
				next('/error');
			}
		}
	},

	{ 
		path: '/admin/orgs/:id',
		name: 'orgs.show', 
		component: require('../pages/orgs/OrgItem.vue').default
	},	

	{ 
		path: '/admin/orgs/:id/edit',
		name: 'orgs.edit', 
		component: require('../pages/orgs/OrgItemEdit.vue').default,
		async beforeEnter(to, from, next) {
			try {
				var perms = await store.state.perms;
				if (perms.can_create_org) {
					next();
				}
				else {
					next('/error');
				}
			} catch (e) {
				next('/error');
			}
		}
	},	

];

export default orgRoutes;